// @flow
import { combineValidators, composeValidators, hasLengthBetween, isRequired, matchesPattern } from 'revalidate';
import {
    getDeviceById,
    getDeviceConnectionType,
    getDeviceErrorStatus,
    getDeviceFirmwareVersion,
    getDeviceIPAddress,
    getDeviceLastSeen,
    getDeviceMacAddress,
    getDeviceName,
    getDevicePowerSource,
    getDeviceRestartingErrorStatus,
    getDeviceRestartingStatus,
    getDeviceSavingStatus,
    getDeviceSerialNumber,
    getDeviceType,
    getIsHub,
    getIsHubSense,
    getIsHueBridge
} from '~/core/state/devices/selectors';
import { renameDevice, renameZone, restartHub } from '~/core/state/devices/actions';
import { getConfig } from '~/core/state/config/selectors';
import { getHasHub } from '~/core/state/hub/selectors';
import InfoPanel from './component';
import moment from 'moment-timezone';
import { reduxForm } from 'redux-form';

const validate = combineValidators({
    name: composeValidators(
        isRequired({ message: 'required' }),
        hasLengthBetween(1, 20)({ message: 'passwordLength' }),
        matchesPattern(/^[A-Za-z0-9/\s]+$/)({ message: 'invalidCharacters' })
    )()
});

const reduxFormProps = {
    form: 'rename-device',
    fields: ['name'],
    validate
};

const mapStateToProps = (state, { deviceId }) => {
    const props = { id: deviceId };
    const hasHub = getHasHub(state);

    const device = getDeviceById(state, props);
    const deviceName = getDeviceName(state, props).getOrElse('');
    const type = getDeviceType(state, props);
    const ipAddress = getDeviceIPAddress(state, props);
    const isHubSense = hasHub && getIsHubSense(state);
    const macAddress = getDeviceMacAddress(state, props);
    const hasErrored = getDeviceErrorStatus(state, props);
    const saving = getDeviceSavingStatus(state, props);
    const connection = getDeviceConnectionType(state, props);
    const version = getDeviceFirmwareVersion(state, props);
    const power = getDevicePowerSource(state, props);
    const lastSeen = getDeviceLastSeen(state, props);
    const serialNumber = getDeviceSerialNumber(state, props);
    const isRestarting = getDeviceRestartingStatus(state, props);
    const hasRestartingError = getDeviceRestartingErrorStatus(state, props);

    const zoneId = device && device.props && device.props.zone;
    const tuiId = device && device.props && device.props.tui;

    const connectedDevices = device && device.state && device.state.connectedDevices;

    const isHub = getIsHub(state, props);
    const isHueBridge = getIsHueBridge(state, props);

    const hideRemoveDevice = (getConfig(state, 'cannotRemoveDevice') || []).includes(type);

    return {
        connectedDevices,
        connection,
        device,
        deviceName,
        hasErrored,
        id: deviceId,
        initialValues: { name: deviceName },
        ipAddress,
        isHub,
        isHubSense,
        isHueBridge,
        isRestarting,
        hasRestartingError,
        lastSeen: moment.duration(lastSeen, 'seconds'),
        macAddress,
        power,
        saving,
        serialNumber,
        showRemoveDevice: !hideRemoveDevice,
        tuiId,
        type,
        version,
        zoneId
    };
};

const mapDispatchToProps = {
    renameDevice,
    renameZone,
    restartHub
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { id, zoneProducts, ...stateRest } = stateProps;
    const { restartHub, ...dispatchRest } = dispatchProps;

    return {
        ...stateRest,
        id,
        ...dispatchRest,
        restartHub: () => restartHub({ id }),
        ...ownProps
    };
};

export default reduxForm(reduxFormProps, mapStateToProps, mapDispatchToProps, mergeProps)(InfoPanel);



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/index.js